import Status from "components/base/Status";
import { OdooContext } from "OdooProvider";
import { useContext } from "react";

const InvBillView = ({ company, data, currencySymbol }) => {
  const { odooUrl } = useContext(OdooContext);
  return (
    <div className="-mx-2 text-sm">
      <table className="font-code whitespace-nowrap">
        <thead>
          <tr>
            <th>Due Date</th>
            <th>Name</th>
            <th>Partner</th>
            <th className="w-full">Ref</th>
            <th className="text-right">INV/BILL Amount</th>
            <th className="text-right">Amount Due</th>
            <th>Payment State</th>
          </tr>
        </thead>
        <tbody>
          {data.map((i, index) => (
            <tr key={index} className="border-y dark:border-gray-700">
              <td>{i.due_date}</td>
              <td>
                <a
                  href={`${odooUrl}/odoo/customer-invoices/${i.id}`}
                  rel="noreferer"
                  target="_blank"
                >
                  {i.name}
                </a>
              </td>
              <td>{i.partner_id[1]}</td>
              <td>{i.ref}</td>
              <td className="text-right">
                <div className="text-xs opacity-70">
                  {i.currency}{" "}
                  {i.amount_in_currency.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </div>
                <div>
                  {i.amount.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                  {currencySymbol}
                </div>
              </td>
              <td className="text-right">
                <div className="text-xs opacity-70">
                  {i.currency}{" "}
                  {i.amount_due_in_currency.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </div>
                <div>
                  {i.amount_due.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                  {currencySymbol}
                </div>
              </td>
              <td className="text-right">
                <Status status={i.payment_state} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default InvBillView;
